/**
 * Created by Florin David on 2019-04-27.
 */
import { combineReducers } from 'redux'

import messages from './messages'
import locale from './locale'
import updatedAt from './updatedAt'
import fetchingMessages from './fetchingMessages'

export default combineReducers({
  messages,
  locale,
  updatedAt,
  fetchingMessages,
})
